import axios from "axios"
import React, { useCallback, useMemo, useState } from 'react'
import { notifyError } from "../../shared/notice"

const ReportValue = ({ entry, field }) => {
  const [generatingReport, setGeneratingReport] = useState(false)

  const buttonText = useMemo(() => {
    return [entry.name].filter(i => i).join(' ')
  }, [entry, generatingReport])

  const openPdf = useCallback(async () => {
    setGeneratingReport(true)
    await axios.get(`/mobile-record/${field.recordId}/gis-pdfs-template/${entry.id}.json`)
      .then(res => window.open(res.data, 'noopener,noreferrer'))
      .then(() => setGeneratingReport(false))
      .catch(error => {
        console.error("ERROR::::: ", error)
        notifyError("There was an error generating the PDF. Please try again.")
      })
  }, [entry])

  return (
    <div>
      <button
        className="btn btn-primary font-semibold mx-4 my-4 relative cursor-pointer z-10"
        onClick={ () => openPdf() }
      >
        {`${generatingReport ? 'Generating' : 'View'} ${buttonText}`}
      </button>
    </div>
  )
}

export default ReportValue
